// extracted by mini-css-extract-plugin
module.exports = {"responsiveTable":"PDFGenerator_responsiveTable__SKgZI"};